import { render, staticRenderFns } from "./NowhowMessageOverlay.vue?vue&type=template&id=0a37b85c&scoped=true"
import script from "./NowhowMessageOverlay.vue?vue&type=script&lang=ts"
export * from "./NowhowMessageOverlay.vue?vue&type=script&lang=ts"
import style0 from "./NowhowMessageOverlay.vue?vue&type=style&index=0&id=0a37b85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37b85c",
  null
  
)

export default component.exports